import request from '@/utils/request'

export function getUserBookList(examId) {
  return request({
    url: 'userbooks/question/list/' + examId,
    method: 'get'
  })
}

export function userbookPaging(params) {
  return request({
    url: '/userbooks/paging',
    method: 'get',
    params
  })
}

export function getSingleQu(quId) {
  return request({
    url: 'userbooks/question/single/' + quId,
    method: 'get'
  })
}

export function fullBook(data) {
  return request({
    url: 'userbooks/full-book',
    method: 'post',
    data
  })
}

// 搜索错题
export function searchWrongQuestion(content) {
  return request({
    url: '/wrong-question/search',
    method: 'get',
    params: { content }
  })
}

// 获取学生的错题列表
export function getStudentWrongQuestions(studentId) {
  return request({
    url: `/wrong-question/student/${studentId}`,
    method: 'get'
  })
}

// 获取学生在指定课程的错题列表
export function getStudentWrongQuestionsByCourse(studentId, courseId) {
  return request({
    url: `/wrong-question/student/${studentId}/course/${courseId}`,
    method: 'get'
  })
}

// 获取知识点列表
export function getKnowledgeList(params) {
  return request({
    url: '/knowledge/getContent',
    method: 'get',
    params
  })
}

// 添加错题
export function addWrongQuestion(data) {
  return request({
    url: '/wrong-question',
    method: 'post',
    data
  })
}

// 删除错题
export function deleteWrongQuestion(id) {
  return request({
    url: `/wrong-question/${id}`,
    method: 'delete'
  })
}

export function updateWrongQuestion(id, data) {
  return request({
    url: `/wrong-question/${id}`,
    method: 'put',
    data
  })
}
